var _jsxFileName = "/builds/zillow/hackweek/military-rent-affordability-calculator/src/components/MilitaryRentAffordabilityCalculator/mrac-base-pay-statement/index.jsx",
    _this = this;

import React from 'react';
import { Paragraph } from '@zillow/constellation';
import PropTypes from 'prop-types';

var MilitaryBasePayStatement = function MilitaryBasePayStatement(_ref) {
  var militaryPaygrade = _ref.militaryPaygrade,
      lengthOfService = _ref.lengthOfService,
      basePay = _ref.basePay;

  var buildUnfulfilledParamsStatement = function buildUnfulfilledParamsStatement() {
    var missingValues = [];

    if (militaryPaygrade == null) {
      missingValues.push('Paygrade');
    }

    if (lengthOfService == null) {
      missingValues.push('Length of Service');
    }

    var missingValuesStatement = null;

    if (missingValues.length > 0) {
      missingValuesStatement = missingValues.join(' and ');
    } else {
      return null;
    }

    var lastCommaIndex = missingValuesStatement.lastIndexOf(', ');

    if (lastCommaIndex > 0) {
      missingValuesStatement = missingValuesStatement.substring(0, lastCommaIndex + 1) + " and" + missingValuesStatement.substring(lastCommaIndex + 1);
    }

    return missingValuesStatement;
  };

  var unfulfilledParamsStatement = buildUnfulfilledParamsStatement();

  if (unfulfilledParamsStatement != null) {
    return /*#__PURE__*/React.createElement(Paragraph, {
      marginY: "md",
      __self: _this,
      __source: {
        fileName: _jsxFileName,
        lineNumber: 37,
        columnNumber: 13
      }
    }, "Please enter your ", /*#__PURE__*/React.createElement("strong", {
      __self: _this,
      __source: {
        fileName: _jsxFileName,
        lineNumber: 38,
        columnNumber: 35
      }
    }, unfulfilledParamsStatement), " to find your active duty base pay");
  }

  if (basePay != null) {
    return /*#__PURE__*/React.createElement(Paragraph, {
      marginY: "md",
      __self: _this,
      __source: {
        fileName: _jsxFileName,
        lineNumber: 45,
        columnNumber: 13
      }
    }, "Your monthly active duty base pay is", ' ', /*#__PURE__*/React.createElement("strong", {
      __self: _this,
      __source: {
        fileName: _jsxFileName,
        lineNumber: 47,
        columnNumber: 17
      }
    }, basePay.toLocaleString('en-US', {
      style: 'currency',
      currency: 'USD'
    }), "/mo"));
  }

  return /*#__PURE__*/React.createElement(Paragraph, {
    marginY: "md",
    __self: _this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 53,
      columnNumber: 12
    }
  }, "Unable to determine your active duty base pay");
};

MilitaryBasePayStatement.propTypes = process.env.NODE_ENV !== "production" ? {
  militaryPaygrade: PropTypes.string.isRequired,
  lengthOfService: PropTypes.string.isRequired,
  basePay: PropTypes.number.isRequired
} : {};
export default MilitaryBasePayStatement;